var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "25px",
    height: "25px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14.5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1Zm10.75 12.05c-.59.57-.17 1.53.67 1.53h.16v1.8h-.16c-.84 0-1.26.96-.67 1.52l.12.11-1.33 1.27-.11-.1c-.59-.57-1.6-.17-1.6.63v.15H6.96v-.16c0-.8-1-1.2-1.6-.63l-.11.11-1.33-1.27.12-.1c.59-.57.17-1.54-.66-1.54H3.2v-1.79h.17c.83 0 1.25-.96.66-1.53l-.12-.1 1.33-1.27.11.1c.6.57 1.6.17 1.6-.63V10h1.87v.15c0 .8 1.01 1.2 1.6.64l.11-.11 1.33 1.27-.12.1Zm-6.2 2.43a2.3 2.3 0 0 0 2.35 2.24c1.29 0 2.34-1 2.34-2.24a2.3 2.3 0 0 0-2.34-2.24c-1.3 0-2.34 1-2.34 2.24ZM1.62 2.31h8.84v.77H1.6V2.3Zm3.21 1.54H1.61v.77h3.21v-.77Zm6.43-1.54h3.22v.77h-3.22V2.3Zm3.22 1.54H5.63v.77h8.84v-.77ZM1.6 5.38h12.86v.77H1.6v-.77ZM14.47 7H1.6v.77h12.86V7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.26.83A.85.85 0 0 0 17.4 0h-.87c.48 0 .87.37.87.83v18.34c0 .46-.39.83-.87.83h.87c.48 0 .87-.37.87-.83V.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 .83c0-.46-.4-.83-.88-.83h-.88c.48 0 .88.37.88.83v18.34c0 .46-.4.83-.88.83h.88c.49 0 .88-.37.88-.83V.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReports);
export default ForwardRef;